// extracted by mini-css-extract-plugin
export var list = "survey-session-list-module--list--ncp-7";
export var loader = "survey-session-list-module--loader--xt7xo";